import { Navigate, useLocation } from "react-router-dom";
import { type ReactNode } from "react";
import { getAuthToken } from "@/lib/api";

export default function AuthGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!getAuthToken()) {
    return (
      <Navigate to="/dashboard/login" state={{ from: location.pathname }} replace />
    );
  }
  return <>{children}</>;
}
